import { createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import reducer from "./fetchData";

const configureStore = preloadedState =>
  createStore(reducer, preloadedState, applyMiddleware(thunk));

export default configureStore;



// WEBPACK FOOTER //
// src/shared/configureStore.js